import { IDatasource } from '../interfaces';

export class DatasourceGdal implements IDatasource {
    type = 'gdal';
    name: string;
    id: number;
    mosaic = false;

    constructor(data?: IDatasource) {
        if (data) { Object.assign(this, data); }
    }
}
